import React from 'react';
import { Icon } from '@beisen/chaos-ui';
require('./icon.css');

class BS_Icon extends React.Component {
    constructor(props,context) {
        super(props,context);
        this.handleTouchTap = this.handleTouchTap.bind(this);
    }
    handleTouchTap(e) {
        if(this.props.onTouchTap) {
          this.props.onTouchTap(e);
        }
    }
    render() {
        const { data } = this.props;
        return (
            <Icon {...this.props} onTouchTap={this.handleTouchTap} />
        );
    }
}

export default BS_Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js